// extracted by mini-css-extract-plugin
module.exports = {"cls1":"AssignmentForm-Shortcuts-module--cls1--1JbNI","cls2":"AssignmentForm-Shortcuts-module--cls2--34jQm AssignmentForm-Shortcuts-module--cls1--1JbNI"};